import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, signal, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ReelsService } from "@src/app/servicios/reels.service";
import { first, Subscription } from "rxjs";
import { ConfigService } from "src/app/servicios/config/config.service";
import { PlatformService } from "src/app/servicios/platform/platform.service";
import { SidenavService } from "../../servicios/sidenav/sidenav.service";
import { ReelsComponent } from "../reels/reels.component";

@Component({
  selector: "app-home-reels",
  templateUrl: "./home-reels.component.html",
  styleUrls: ["./home-reels.component.css"],
  imports: [ReelsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeReelsComponent implements OnInit, OnDestroy {
  @ViewChild("container", { static: false }) container: ElementRef;
  arraLikesComents = signal(new Map<number, any>());
  noticiasFijadas = signal([]);
  likesNoticias = signal([]);
  ads = signal([]);
  constantesGlobales;
  entradillaVisible = false;
  rrssVisible = false;
  userLogin: any;
  likesComents = signal([]);
  scrollSub: Subscription;
  portadaReels: boolean = false;

  numLikes = signal(0);
  numComents = signal(0);
  likesUser: boolean;

  // animaciones = ['zoomInOut', 'slideFromCenter', 'zoomOutIn', 'slideFromCenterReverse'];
  animaciones = ["zoomInOut", "zoomOutIn"];

  constructor(
    private sidenav: SidenavService,
    private elementRef: ElementRef,
    public dialog: MatDialog,
    private platformService: PlatformService,
    private configService: ConfigService,
    private reelsService: ReelsService,
  ) {
    this.constantesGlobales = this.configService.getConstantesGlobales();
    const configPrensa = configService.getConfigPrensa();
    if (configPrensa) {
      configPrensa.pipe(first()).subscribe((config) => {
        if (config && config.general["app-home"].portada_reels_movil === "true") {
          this.portadaReels = true;
        }
      });
    }
    this.elementRef.nativeElement.style.setProperty("--background-color", this.constantesGlobales.color);
  }

  ngOnInit(): void {
    if (this.platformService.isBrowser()) {
      document.body.classList.add("no-scroll");
    }

    this.sidenav.setIsScrolled(false);
    this.sidenav.setLogoVisibility(false);
  }

  ngOnDestroy(): void {
    if (this.platformService.isBrowser()) {
      this.sidenav.setIsScrolled(false);
      this.sidenav.setLogoVisibility(false);
      document.body.classList.remove("no-scroll");
    }
  }
}
